<script setup>
import { computed, onMounted, ref } from "vue";

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: "",
    },
    type: {
        type: String,
        default: "text",
    },
});

defineEmits(["update:modelValue"]);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute("autofocus")) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });

const classes = computed(() => {
    // gray out the placeholder text for date input
    if (props.type === "date" && props.modelValue === "") {
        return "text-gray-400";
    }
    return "";
});
</script>

<template>
    <input
        ref="input"
        class="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:placeholder-white focus:ring-blue-500"
        :class="classes"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :type="type"
    />
</template>
